// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"431":"css/app.6985","9177":"css/admin-app.6985"}[chunkId] + ".css";
};